import { Moment } from "moment";

export const SET_WEEK_COUNT = "VRCORE.RESOURCE_PLANNER.SET_WEEK_COUNT";
export const SET_DOCUMENT_TRACK_ORDER =
    "VRCORE.RESOURCE_PLANNER.SET_DOCUMENT_TRACK_ORDER";
export const SET_RESOURCE_POSITIONS =
    "VRCORE.RESOURCE_PLANNER.SET_RESOURCE_POSITIONS";
export const SET_SELECTED_DAY = "VRCORE.RESOURCE_PLANNER.SET_SELECTED_DAY";
export const INCREMENT_START_DATE =
    "VRCORE.RESOURCE_PLANNER.INCREMENT_START_DATE";

export const GET_TRACKS = "VRCORE.RESOURCE_PLANNER.GET_TRACKS";
export const ADD_TRACK = "VRCORE.RESOURCE_PLANNER.ADD_TRACK";
export const DELETE_TRACK = "VRCORE.RESOURCE_PLANNER.DELETE_TRACK";
export const GET_TRACK_SUBJECTS = "VRCORE.RESOURCE_PLANNER.GET_TRACK_SUBJECTS";
export const GET_TRACK_ORDER = "VRCORE.RESOURCE_PLANNER.GET_TRACK_ORDER";
export const GET_RESOURCES = "VRCORE.RESOURCE_PLANNER.GET_RESOURCES";
export const ADD_RESOURCE = "VRCORE.RESOURCE_PLANNER.ADD_RESOURCE";
export const DELETE_RESOURCE = "VRCORE.RESOURCE_PLANNER.DELETE_RESOURCE";
export const GET_RESOURCE_SUBJECTS =
    "VRCORE.RESOURCE_PLANNER.GET_RESOURCE_SUBJECTS";
export const GET_CHOSEN_TRACK_SUBJECTS =
    "VRCORE.RESOURCE_PLANNER.GET_CHOSEN_TRACK_SUBJECTS";
export const SET_CHOSEN_TRACK_SUBJECTS =
    "VRCORE.RESOURCE_PLANNER.SET_CHOSEN_TRACK_SUBJECTS";

export const GET_RESOURCE_PLANNER_DOCUMENT =
    "VRCORE.RESOURCE_PLANNER.GET_RESOURCE_PLANNER_DOCUMENT";
export const SET_RESOURCE_PLANNER_DOCUMENT =
    "VRCORE.RESOURCE_PLANNER.SET_RESOURCE_PLANNER_DOCUMENT";

export const GET_JOBPACKS = "VRCORE.RESOURCE_PLANNER.GET_JOBPACKS";

interface GetJobpacksAction {
    type: typeof GET_JOBPACKS;
    payload: any;
}

interface GetTrackOrderAction {
    type: typeof GET_TRACK_ORDER;
    payload: string[];
}

interface GetTrackSubjectsAction {
    type: typeof GET_TRACK_SUBJECTS;
    payload: { [index: string]: string };
}

interface GetResourceSubjectsAction {
    type: typeof GET_TRACK_SUBJECTS;
    payload: { [index: string]: string };
}
interface SetWeekCountAction {
    type: typeof SET_WEEK_COUNT;
    payload: number;
}

interface IncrementStartDateAction {
    type: typeof INCREMENT_START_DATE;
    payload: Moment;
}

export interface IResourcePositions {
    [index: string]: {
        track: string;
        index: number;
    };
}
interface SetResourcePositionsAction {
    type: typeof SET_RESOURCE_POSITIONS;
    payload: Array<IResourcePositions>;
}

export interface IResourcePlannerDocument {
    trackOrder: string[];
    resourcePositions: Array<IResourcePositions> | false;
}

export interface GetResourcePlannerDocumentAction {
    type: typeof GET_RESOURCE_PLANNER_DOCUMENT;
    payload: IResourcePlannerDocument;
}

export interface SetResourcePlannerDocumentAction {
    type: typeof SET_RESOURCE_PLANNER_DOCUMENT;
    payload: IResourcePlannerDocument;
}

export type ISetDocumentTrackOrderActionPayload = Array<string>;

export type IIncrementStartDatePayload = Moment;
interface SetDocumentTrackOrderAction {
    type: typeof SET_DOCUMENT_TRACK_ORDER;
    payload: ISetDocumentTrackOrderActionPayload;
}

interface SetSelectedDayAction {
    type: typeof SET_SELECTED_DAY;
    payload: number;
}

interface GetChosenTrackSubjects {
    type: typeof GET_CHOSEN_TRACK_SUBJECTS;
    payload: Array<string>;
}

export type ResourcePlannerActionTypes =
    | SetWeekCountAction
    | SetDocumentTrackOrderAction
    | SetResourcePositionsAction
    | SetSelectedDayAction
    | IncrementStartDateAction
    | GetTrackSubjectsAction
    | GetResourceSubjectsAction
    | GetChosenTrackSubjects
    | GetResourcePlannerDocumentAction
    | SetResourcePlannerDocumentAction
    | GetJobpacksAction
    | GetTrackOrderAction;
